module.exports = __webpack_public_path__ + "static/img/background.c055f78f.svg";